import { createContext } from "react";

export const ThemeContext: any = createContext<any>(null);
